/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Measuringpoint } from "./Measuringpoint";
import {
  MeasuringpointFromJSON,
  MeasuringpointFromJSONTyped,
  MeasuringpointToJSON,
  MeasuringpointToJSONTyped,
} from "./Measuringpoint";

/**
 *
 * @export
 * @interface ApiGmnMeasuringpointsList200Response
 */
export interface ApiGmnMeasuringpointsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmnMeasuringpointsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmnMeasuringpointsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmnMeasuringpointsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Measuringpoint>}
   * @memberof ApiGmnMeasuringpointsList200Response
   */
  results: Array<Measuringpoint>;
}

/**
 * Check if a given object implements the ApiGmnMeasuringpointsList200Response interface.
 */
export function instanceOfApiGmnMeasuringpointsList200Response(
  value: object
): value is ApiGmnMeasuringpointsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmnMeasuringpointsList200ResponseFromJSON(
  json: any
): ApiGmnMeasuringpointsList200Response {
  return ApiGmnMeasuringpointsList200ResponseFromJSONTyped(json, false);
}

export function ApiGmnMeasuringpointsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmnMeasuringpointsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(MeasuringpointFromJSON),
  };
}

export function ApiGmnMeasuringpointsList200ResponseToJSON(
  json: any
): ApiGmnMeasuringpointsList200Response {
  return ApiGmnMeasuringpointsList200ResponseToJSONTyped(json, false);
}

export function ApiGmnMeasuringpointsList200ResponseToJSONTyped(
  value?: ApiGmnMeasuringpointsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(MeasuringpointToJSON),
  };
}
